import { render, staticRenderFns } from "./AdminBackground.vue?vue&type=template&id=5ad4768a&scoped=true&"
import script from "./AdminBackground.vue?vue&type=script&setup=true&lang=js&"
export * from "./AdminBackground.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AdminBackground.vue?vue&type=style&index=0&id=5ad4768a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad4768a",
  null
  
)

export default component.exports